export default __webpack_public_path__ + "static/teacher-29a4dd26483acf66b92fde2c51e76aa6.png";